export default __webpack_public_path__ + "static/129-min-min-152e187fbc6b38417cfb2ab926d0f01f.jpg";